module.exports = __webpack_public_path__ + "img/sellercloud-logo.cc68cd71.jpeg";